<template>
    <div class="search-bar mb-3 my-2 my-sm-0" style="min-width: 400px">
        <amf-search-box :search="search" @select="select" :show-clear-button="showClearButton" @clear="clear" optionsComponent="system-search-options"></amf-search-box>
    </div>
</template>

<script>
import Popper from "popper.js";
import $ from "jquery";
import Vue from 'vue';

    export default {
        data() {
            return {
                amfOptions: { layout: "custom", noTracking: true },
            }
        },
        props: {
            showClearButton: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            async search(text, options) {
                var searchCriteria = {
                    text: text,
                    searchDependents: false,
                    ...options
                };
                let results = _.take(await romeApi.get("/system/search", searchCriteria), 20);
                return results.map(this.mapSearchResult);
            },

            async select(result) {
                this.$emit("select", result);
            },

            async clear() {
                this.$emit("clear");
            },

            mapSearchResult(result) {
                if (result.type == "participant") {
                    return {
                        entityType: result.type,
                        id: result.participantId,
                        parentId: result.parentId,
                        employerId: result.employerId,
                        icon: result.parentId ? "fa-plus" : "fa-user",
                        url: `/participant/${result.parentId ? result.parentId : result.participantId}/general`,
                        title: `${result.firstName} ${result.lastName} (${result.employerName})`
                    };
                } else if (result.type == "employer") {
                    return {
                        entityType: result.type,
                        id: result.employerId,
                        icon: "fa-building",
                        url: `/employer/${result.employerId}/main`,
                        title: `${result.employerName}`
                    }
                } else if (result.type == "broker" || result.type == "agency" || result.type == "partner") {
                    return {
                        entityType: result.type,
                        id: result.id,
                        icon: "fa-id-badge",
                        url: `/${result.type}/${result.id}/general`,
                        title: `${result.name} - ${result.type}`
                };
                } else {
                    return { id: null, title: "Unrecognized" }
                }
            }

        },
    }
</script>



// WEBPACK FOOTER //
// src/framework/SystemSearchBar.vue